export const signInSuccess = (user) =>
	({
		type: 'SIGN_IN_SUCCESS',
		payload: { user }
	});

export const signOutSuccess = () =>
	({
		type: 'SIGN_OUT_SUCCESS'
	});

export const updateAccount = (user) =>
	({
		type: 'UPDATE_ACCOUNT',
		payload: { user }
	});

export const updatePlan = (plan, active) =>
	({
		type: 'UPDATE_PLAN',
		payload: { plan, active }
	});

export const updateActiveRoom = (room) =>
	({
		type: 'UPDATE_ACTIVE_ROOM',
		payload: { room }
	});

export const updateAdmittedStatus = (admitted) =>
	({
		type: 'UPDATE_ADMITTED_STATUS',
		payload: { admitted }
	});
